import { Action, ErrorCodes, OperationType } from "puzzle";
import ExportViewer from "../../components/Drawer/Tabs/Files/ExportViewer";

export const getTaskOnlineEditorAddress: Action = [{
  persistent: ['selectedTask'],
  type: OperationType.addPersistentData
}, {
  data: {
    template: {
      method: 'get',
      bind: {
        url: "'/jobPhases/' + {selectedTask.taskId} + '/editor/urls'",
        params: '{onlineEditorParams}'
      }
    }
  },
  handleErrorStatuses: [
    ErrorCodes.FORBIDDEN,
    ErrorCodes.NOT_FOUND,
    ErrorCodes.BAD_REQUEST,
    ErrorCodes.INTERNAL_SERVER_ERROR
  ],
  mappingName: 'onlineEditorUrl',
  type: OperationType.request
}, {
  condition: `!_.get({onlineEditorUrl}, "response.data.errors")}`,
  conditionOperations: [{
    condition: '{onlineEditorUrl[0].editorUrl.indexOf("exportViewer") > -1}',
    conditionOperations: [{
      children: [{
        render: ExportViewer,
        propArgs: ['onlineEditorUrl']
      }],
      className: 'xl',
      title: 'exportViewer.title',
      type: OperationType.dialog
    }, {
      type: OperationType.removePersistentData,
      persistent: ['selectedTask']
    }],
    elseOperations: [{
      condition: '{onlineEditorUrl[0].editorUrl}.includes("payloadId") || {onlineEditorUrl[0].editorUrl}.includes("editorSessionId")',
      conditionOperations: [{
        moduleName: 'ActionExecutor',
        name: 'prepareEditorOpen',
        args: ['onlineEditorUrl', 'onlineEditorParams']
      }],
      elseOperations: [{
        data: {
          addTheme: false
        },
        moduleName: 'ActionExecutor',
        name: 'openInPreviewMode',
        args: ['onlineEditorUrl', 'addTheme']
      }],
      type: OperationType.conditional
    }],
    type: OperationType.conditional
  }],
  elseOperations: [{
    name: 'filesTabWarningTemplate',
    type: OperationType.action
  }, {
    type: OperationType.removePersistentData,
    persistent: ['selectedTask']
  }],
  type: OperationType.conditional
}];


export const processSupplierEditorClose: Action = [{
  condition: '{pingData} && {pingData.processingFinished}',
  conditionOperations: [{
    condition: '{pingData.uploadReportsDto}',
    conditionOperations: [{
      type: OperationType.removePersistentData,
      persistent: ['selectedTask']
    }, {
      actionType: {
        dispatcherId: 'mainDispatcher'
      },
      name: 'supplierTsoNotification',
      type: OperationType.action
    }],
    type: OperationType.conditional
  }, {
    actionType: {
      dispatcherId: 'mainDispatcher'
    },
    name: 'refreshApp',
    type: OperationType.action
  }, {
    dispatcherIds: ['batchPingDispatcher'],
    type: OperationType.unlink
  }],
  elseOperations: [{
    condition: '!_.get({pingData}, "response.data.errors")}',
    conditionOperations: [{
      actionType: {
        dispatcherId: "batchPingDispatcher",
        delay: 1000
      },
      data: {
        template: {
          bind: {
            editorSessionId: '{pingParam.editorSessionId}'
          }
        }
      },
      name: 'supplierPingBatchRequest',
      type: OperationType.stack
    }],
    type: OperationType.conditional
  }],
  type: OperationType.conditional
}];


export const supplierPingBatchRequest: Action = [{
  data: {
    template: {
      method: 'get',
      bind: {
        url: "'/submissions/' + {selectedTask.submissionId} +'/upload/report/' + {editorSessionId}"
      }
    }
  },
  handleErrorStatuses: [
    ErrorCodes.FORBIDDEN,
    ErrorCodes.NOT_FOUND,
    ErrorCodes.BAD_REQUEST,
    ErrorCodes.INTERNAL_SERVER_ERROR
  ],
  mappingName: 'pingData',
  type: OperationType.request,
}, {
  data: {
    template: {
      bind: {
        responseData: '{pingData}',
      }
    }
  },
  name: 'handleRequestException',
  type: OperationType.action
}, {
  items: ['pingData'],
  type: OperationType.syncDispatchersDataItem
}, {
  name: 'processSupplierEditorClose',
  type: OperationType.action
}];

export const supplierTsoNotification: Action = [{
  moduleName: 'ActionExecutor',
  name: 'getTSOUploadNotification',
  args: ['pingData'],
  mappingName: 'tsoNotification',
  type: OperationType.addOperationData
}, {
  moduleName: 'ToastNotifications',
  name: 'setNotification',
  args: ['tsoNotification']
}];

